import React from "react";
import { Spinner } from "react-bootstrap";
import Typography from "../../../components/typography/Typography";

import styles from "./details-page.module.scss";

const loadingHeaderTypeLabels = {
  url: "URL",
  sample: "sample"
};

type SummaryLoadingHeaderProps = {
  type: "url" | "sample";
};

const DetailsPageLoadingHeader: React.FC<SummaryLoadingHeaderProps> = ({
  type
}) => (
  <div className={styles.container} data-testid="summary_loading_container">
    <div className={styles.iconContainer}>
      <Spinner
        animation="border"
        variant="primary"
        className={styles.spinner}
      />
    </div>
    <div className={styles.textContainer}>
      <Typography variant="h3" className="mb-5">
        The {loadingHeaderTypeLabels[type]} analysis is in progress...
      </Typography>
      <Typography variant="body1">
        Depending on the load, this might take some time...
        <br />
        The page will update automatically when the data is ready, you do not
        have to refresh this page.
      </Typography>
    </div>
  </div>
);

export default DetailsPageLoadingHeader;
